enum FormatEnum {
	ORIGINAL = "original",
	CUSTOM = "custom"
}

export default FormatEnum;